export default {
  placeholder: 'Vybrať štítky',
  tagPlaceholder: 'Pridať nový štítok',
};
